if(!customElements.get('localization-form')){
    class LocalizationForm extends HTMLElement {
        constructor(){
            super();

            this.initFooter();
            this.initHeader();
        }

        initHeader(){
            if(this.closest('custom-footer')) return;

            this.btn = this.querySelector('.btn-locale');
            this.panel = this.querySelector('.nav-dropdown-wrapper');

            this.input = this.querySelector('input[name="locale_code"], input[name="country_code"]');
            this.selectWrapper = this.querySelector('.localization-select-wrapper');

            this.selectWrapper.querySelector('.btn-locale').addEventListener('keydown', this.optionKeydownEventHandler.bind(this));

            // Option event handler
            this.querySelectorAll('a').forEach((item) => {
                item.addEventListener('click', this.clickOption.bind(this));
                item.addEventListener('keydown', this.optionKeydownEventHandler.bind(this))
            })
        }

        initFooter(){
            if(this.closest('custom-header')) return;
            
            // Locale button
            this.btn = this.querySelector('.btn-locale');
            this.panel = this.querySelector('.select-options');

            this.btn.addEventListener('click', this.openOptions.bind(this));
            this.btn.addEventListener('focusout', this.closeOptions.bind(this));

            document.addEventListener('click', (event) => {
                if(event.target !== this && event.target.closest('localization-form') !== this){
                    this.closeOptions(event);
                }
            })
        
            this.input = this.querySelector('input[name="locale_code"], input[name="country_code"]');

            // Option event handler
            this.querySelectorAll('a').forEach((item) => {
                item.addEventListener('click', this.clickOption.bind(this));
                item.addEventListener('keydown', this.optionKeydownEventHandler.bind(this))
            })
        }

        openOptions(e){
            e.preventDefault();
            this.panel.setAttribute('data-hidden', 'false');

            let index = 0;
            const focusElem = setInterval(() => {
                const firstOption = this.panel.querySelectorAll('a')[0];
                firstOption.focus();
                
                var focusedElement = document.activeElement;

                index++;
                if(focusedElement === firstOption || index > 5){
                    clearInterval(focusElem);
                }
            }, 100)
        }

        optionKeydownEventHandler(event){
            const options = this.panel.querySelectorAll('a');

            if(event.key === 'ArrowDown'){
                event.preventDefault();
                var focusableElements = options;
                var currentIndex = Array.from(focusableElements).indexOf(document.activeElement);
                var nextIndex = currentIndex === focusableElements.length - 1 ? currentIndex : currentIndex + 1;
                focusableElements[nextIndex].focus();
            }else if(event.key === 'ArrowUp'){
                event.preventDefault();
                var focusableElements = options;
                var currentIndex = Array.from(focusableElements).indexOf(document.activeElement);
                var nextIndex = currentIndex === 0 ? 0 : currentIndex - 1;
                focusableElements[nextIndex].focus();
            }else if(event.key === 'Escape'){
                this.panel.setAttribute('data-hidden', 'true')
            }
        }

        closeOptions(e){
            if(e.relatedTarget == null || (e.relatedTarget && e.relatedTarget.nodeName === 'BUTTON')){
                if(this.panel) this.panel.setAttribute('data-hidden', 'true');
            }
        }

        clickOption(e){
            e.preventDefault();

            const form = this.querySelector('form');
            this.input.value = e.currentTarget.dataset.value;
            if(form) form.submit();
        }
    }

    customElements.define('localization-form', LocalizationForm);
}